// extracted by mini-css-extract-plugin
export default {"box":"HeadingBefore_box__lxhAD"};